module.exports = __webpack_public_path__ + "media/img/specialize/item_bg-99c144b660dc0028e390a3d2bf0fb699.png";